<template>
  <div class="wrapper">
    
    <Nav>
      <template v-slot:logo-box>
        <Logo/>
      </template>
    </Nav>

    <div class="main">
      <div :class="{'password-change-box': true}">

        <div class="top-row">
          <div class="title">Change Password</div>
        </div>

        <div class="loading-row" v-if="loading">
          <div class="lds-dual-ring"></div>
        </div>

        <div class="bottom-row" v-if="!loading">

          <div class="input-row">
            <div class="input-box">
              <div class="frame">
                <div class="name" :class="{ name_error: newPasswordError }">
                  <span class="label">New password</span>
                  <span class="info">
                    <font-awesome-icon icon="info-circle" />
                    <span class="info_box">
                      <div class="label">Requirements:</div>
                      <span class="req">has min 8 characters</span>
                      <span class="req">has max 8 characters</span>
                      <span class="req">has uppercase</span>
                      <span class="req">has lowercase</span>
                      <span class="req">has digits</span>
                      <span class="req">has not spaces</span>
                    </span>
                  </span>
                  <span class="error">{{ newPasswordError }}</span>
                </div>
                <div class="input">
                  <input type="password" v-model="newPassword" :class="{ input_error: newPasswordError }" @input="newPasswordError = null">
                </div>
              </div>
            </div>
          </div>

          <div class="input-row">
            <div class="input-box">
              <div class="frame">
                <div class="name" :class="{ name_error: repeatPasswordError }">
                  <span class="label">Repeat new password</span>
                  <span class="error">{{ repeatPasswordError }}</span>
                </div>
                <div class="input">
                  <input type="password" v-model="repeatPassword" :class="{ input_error: repeatPasswordError }" @input="repeatPasswordError = null" @keypress.enter="onChange">
                </div>
              </div>
            </div>
          </div>

          <div class="button-row">
            <div class="frame">
              <button @click="onChange" :class="{'inactive': globalError}">Change</button>
            </div>
          </div>

        </div>

        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import alert from '@/lib/alert';
import swal from 'sweetalert'
import passwordValidator from 'password-validator';
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'

let schema = new passwordValidator();
schema
.is().min(8)
.is().max(30)
.has().uppercase()
.has().lowercase()
.has().digits()
.has().not().spaces()
.is().not().oneOf(['Passw0rd', 'Password123']);

export default {
  name: 'ResetPassword',
  data() {
    return {
      loading: false,
      newPassword: '',
      newPasswordError: null,
      repeatPassword: '',
      repeatPasswordError: null
    }
  },
  components: {
    //Nav
    Nav,
    Logo
  },
  methods: {
    checkResetCode(code) {
      axios.post(`${process.env.VUE_APP_SERVER_URL}checkResetCode`, {
        code
      })
      .then(() => {
        console.log('valid');
      })
      .catch(() => {
        this.showError();
      });
    },
    showError() {
      swal({
        title: "Invalid Link",
        text: " ",
        icon: "error",
        button: false,
        timer: 3000
      }).then(() => {
        this.$router.push('/');
      })
    },
    checkNewPassword() {
      let error = false;
      if(this.newPassword.trim() == '') {
        error = true;
        this.newPasswordError = 'is required';
        this.newPassword = '';
      } else if(!schema.validate(this.newPassword)) {
        error = true;
        this.newPasswordError = 'is invalid';
        this.newPassword = '';
      }
      if(error) {
        return false
      } else {
        return true
      }
    },
    checkRepeatPassword() {
      let error = false;
      if(this.repeatPassword != this.newPassword) {
        error = true;
        this.repeatPasswordError = 'not maching';
        this.repeatPassword = '';
      }
      if(error) {
        return false
      } else {
        return true
      }
    },
    onChange() {
      if(!this.newPasswordError && !this.repeatPasswordError && !this.globalError) {
        const validNewPassword = this.checkNewPassword();
        const validRepeatPassword = this.checkRepeatPassword();
        if(validNewPassword && validRepeatPassword) {
          this.submit();
        }
      }
    },
    submit() {
      this.loading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changePasswordWithCode`,
        data: {
          code: this.$route.params.id,
          password: this.newPassword
        }
      }).then(() => {
        this.loading = false;
        alert.showSuccess('Password Changed', 2000);
        localStorage.removeItem('token');
        this.$router.push('/');
      }).catch(err => {
        this.loading = false;
        console.log(err.response);
        alert.showError('Password Change Error', 2000);
      })
    }
  },
  mounted() {
    this.checkResetCode(this.$route.params.id);
  },
  computed: {
    globalError() {
      if(!this.newPasswordError && !this.repeatPasswordError && this.newPassword.trim() != '' && this.repeatPassword.trim() != '') {
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.main {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.password-change-box {
  z-index: 100;
  width: 30rem;
  height: auto;
  background-color: whitesmoke;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;
  // overflow: hidden;

  @media (max-width: 600px) {
    width: 90vw;
    height: auto;
    position: absolute;
    top: 10rem;
  }
}

.top-row {
  width: 100%;
  height: 5rem;
  background-color: #11b6a5;
  display: flex;
  flex-direction: row;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;

  .title {
    flex: auto;
    height: 100%;
    display: flex;
    align-items: center;
    color: white;
    font-size: 1.5rem;
    padding-left: 2rem;
  }

  .close {
    width: 5rem;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 1.2rem;

    .icon {
      transition: 0.2s;

      &:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }
  }
}

.loading-row {
  width: 100%;
  height: 17rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-row {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 600px) {
    height: auto;
  }
  padding-top: 2rem;
  padding-bottom: 1rem;
  border-bottom-left-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;

  .input-row {
    width: 100%;
    height: auto;
  }

  .button-row {
    width: 100%;
    height: 3rem;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .inactive {
      filter: saturate(0);
      &:hover {
        background-color: #11b6a5;
        cursor: unset;
      }
    }

    button {
      width: auto;
      padding-left: 0.6rem;
      padding-right: 0.6rem;
      height: 2rem;
      background-color: #11b6a5;
      color: white;
      border: none;
      outline: none;
      border-radius: 0.2rem;
      font-size: 1.1rem;
      font-weight: bold;
      transition: 0.2s;

      &:hover {
        cursor: pointer;
        background-color: #10a899;
      }
    }
  }

  .input-box {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .info {
      margin-left: 0.5rem;
      font-size: 0.9rem;
      cursor: pointer;
      position: relative;
      transition: 0.2s;

      &:hover {
        color: #e6c17d;
      }

      .info_box {
        bottom: 1.1rem;
        left: 0.8rem;
        position: absolute;
        width: 10rem;
        height: 10rem;
        z-index: 10;
        background-color: #e6c17d;
        border-radius: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        visibility: hidden;
        border: 1px solid #c29e5b;
        color: rgb(37, 38, 41);

        .label {
          margin-top: 0.5rem;
          margin-bottom: 0.1rem;
        }

        .req {
          width: 100%;
          padding-left: 0.8rem;
        }
      }

      &:hover .info_box {
        visibility: visible;
      }
    }
    
    .name {
      width: 100%;
      height: 2rem;
      display: flex;
      align-items: center;
      font-size: 1.1rem;
      color: rgb(172, 169, 169);

      .label {
        font-weight: bold;
      }

      .error {
        margin-left: 0.5rem;
        font-style: italic;
      }
    }

    .name_error {
      color: rgb(239, 70, 70);
    }

    .input_error {
      border-color: rgb(239, 70, 70) !important;
    }

    .input {
      width: 100%;
      flex: auto;
      display: flex;

      input {
        width: 100%;
        height: 2rem;
        background: none;
        border: none;
        outline: none;
        background-color: rgb(226, 225, 225);
        font-size: 1rem;
        color: rgb(37, 38, 41);
        transition: 0.2s;
        border: 1px rgb(202, 201, 201) solid;
        border-radius: 0.1rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        @media (max-width: 600px) {
          height: 2.5rem;
        }
      }

      input:focus {
        border-color: #11b6a5;
      }
    }
  }
}

//Loading Circle
.lds-dual-ring {
  display: inline-block;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 84px;
  height: 84px;
  margin: 8px;
  border-radius: 50%;
  border: 7px solid rgba(169, 169, 169, 0.692);
  border-color: rgba(169, 169, 169, 0.692) transparent rgba(169, 169, 169, 0.692) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>